import FinishCompanyBankAccountSetupBanner from "./FinishCompanyBankAccountSetupBanner";

export default FinishCompanyBankAccountSetupBanner;
